import { QuestionCircleIcon } from '@mm/icons';
import { colors } from '@mm/utils';
import classNames from 'classnames';
import React from 'react';
import { Tooltip } from '../Tooltip/Tooltip';
import { Heading, HeadingProps } from '../Heading/Heading';
import './TooltipHeading.pcss';

type Props = HeadingProps & {
  tooltip?: React.ReactNode | React.ReactNode[];
  tooltipColor?: string;
};

export const TooltipHeading = ({
  className,
  text,
  children,
  tooltip,
  tooltipColor,
  ...props
}: Props) => {
  const computedClassName = classNames(
    'c-tooltip-heading',

    className,
  );
  let content: React.ReactNode = text || children;
  if (tooltip) {
    content = (
      <>
        <div>{content}</div>
        <Tooltip
          css={{ content: 'c-tooltip-heading-tooltip-content' }}
          anchorElement={
            <QuestionCircleIcon
              className="c-tooltip-heading-tooltip-anchor-icon"
              color={tooltipColor ? tooltipColor : colors.accentBlue}
            />
          }
        >
          {tooltip}
        </Tooltip>
      </>
    );
  }
  return (
    <Heading className={computedClassName} {...props}>
      {content}
    </Heading>
  );
};
